(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after-toggle"] && !Shopify.designMode) return;
  try {
    
  function initBAToggles() {
    const sections = document.querySelectorAll('.ba-toggle');
    sections.forEach(section => {
      const btns = section.querySelectorAll('.ba-toggle__btn');
      const panes = section.querySelectorAll('.ba-toggle__pane');

      btns.forEach(btn => {
        btn.addEventListener('click', () => {
          const target = btn.dataset.target;
          
          btns.forEach(b => {
            b.classList.remove('is-active');
            b.setAttribute('aria-pressed', 'false');
          });
          panes.forEach(p => p.classList.remove('is-active'));
          
          btn.classList.add('is-active');
          btn.setAttribute('aria-pressed', 'true');
          section.querySelector(`[data-pane="${target}"]`).classList.add('is-active');
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initBAToggles);
  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', initBAToggles);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-before-after"] && !Shopify.designMode) return;
  try {
    
  function initBAComparisons() {
    const comparisons = document.querySelectorAll('[id^="ba-"]');
    comparisons.forEach(comp => {
      const range  = comp.querySelector('.ba__range');
      const after  = comp.querySelector('.ba__panel--after');
      const handle = comp.querySelector('.ba__handle');
      if (!range || !after || !handle) return;

      function update(val) {
        after.style.clipPath  = 'inset(0 ' + (100 - val) + '% 0 0)';
        handle.style.left     = val + '%';
      }

      range.addEventListener('input', e => update(e.target.value));

      // Touch support — map touch to range value
      range.addEventListener('touchmove', e => {
        e.preventDefault();
        const rect = comp.getBoundingClientRect();
        const x    = e.touches[0].clientX - rect.left;
        const val  = Math.min(100, Math.max(0, (x / rect.width) * 100));
        range.value = val;
        update(val);
      }, { passive: false });
    });
  }

  document.addEventListener('DOMContentLoaded', initBAComparisons);
  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', initBAComparisons);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-faq"] && !Shopify.designMode) return;
  try {
    
  function initFAQ() {
    const lists = document.querySelectorAll('.faq__list');
    lists.forEach(list => {
      const items = list.querySelectorAll('.faq__item');
      items.forEach(item => {
        const btn    = item.querySelector('.faq__question');
        const answer = item.querySelector('.faq__answer');
        if (!btn || !answer) return;

        btn.addEventListener('click', () => {
          const isOpen = item.classList.contains('is-open');

          // Close all items in this list
          items.forEach(i => {
            i.classList.remove('is-open');
            const b = i.querySelector('.faq__question');
            const a = i.querySelector('.faq__answer');
            if (b) b.setAttribute('aria-expanded', 'false');
            if (a) a.setAttribute('hidden', '');
          });

          // Open the clicked item if it was closed
          if (!isOpen) {
            item.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
            answer.removeAttribute('hidden');
          }
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initFAQ);
  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', initFAQ);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setClip(el, r, x, y) {
      var v = 'circle(' + r + 'px at ' + x + 'px ' + y + 'px)';
      el.style.webkitClipPath = v;
      el.style.clipPath = v;
    }
    function clearClip(el) {
      el.style.webkitClipPath = 'none';
      el.style.clipPath = 'none';
    }

    function initHero(section) {
      var stageA = section.querySelector('.hero__stage--a');
      var stageB = section.querySelector('.hero__stage--b');
      if (!stageA || !stageB) return;

      var toggle      = section.querySelector('.hero__inner--base .hero__toggle');
      var ring        = section.querySelector('.hero__cursor-reveal');
      var revealInner = section.querySelector('.hero__inner--reveal');
      var isStateB    = section.classList.contains('hero--state-b');
      var cursorR     = parseFloat(getComputedStyle(section).getPropertyValue('--cursor-r')) || 180;

      var mx = 0, my = 0, cx = 0, cy = 0;
      var inside = false, rafId = null;

      /* ── Desktop toggle positioning: measure actual image left edge ── */
      function positionToggle() {
        if (window.matchMedia('(max-width: 768px)').matches) return;
        var prodImg = section.querySelector('.hero__stage--a .hero__prod img') ||
                      section.querySelector('.hero__stage--b .hero__prod img');
        if (!prodImg || prodImg.naturalWidth === 0) return;
        var heroRect = section.getBoundingClientRect();
        var imgRect  = prodImg.getBoundingClientRect();
        if (imgRect.width === 0) return;
        /* right = distance from hero's right edge to image's left edge (0 gap) */
        section.style.setProperty('--toggle-right', (heroRect.right - imgRect.left) + 'px');
      }
      /* Run after images load */
      section.querySelectorAll('.hero__prod img').forEach(function (img) {
        if (img.complete && img.naturalWidth > 0) { positionToggle(); }
        else { img.addEventListener('load', positionToggle); }
      });
      /* Re-run on resize (debounced) */
      var _resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(_resizeTimer);
        _resizeTimer = setTimeout(positionToggle, 120);
      });
      /* Immediate attempt (may be a no-op if images not yet loaded) */
      positionToggle();

      function revealEl() { return isStateB ? stageA : stageB; }

      function applyReveal(r, x, y) {
        setClip(revealEl(), r, x, y);
        if (revealInner) setClip(revealInner, r, x, y);
      }

      function applyState() {
        if (isStateB) {
          stageB.style.zIndex = '1'; stageA.style.zIndex = '2';
          clearClip(stageB);
          setClip(stageA, 0, cx, cy);
        } else {
          stageA.style.zIndex = '1'; stageB.style.zIndex = '2';
          clearClip(stageA);
          setClip(stageB, 0, cx, cy);
        }
        if (revealInner) setClip(revealInner, 0, cx, cy);
      }
      applyState();

      function tick() {
        cx += (mx - cx) * 0.12;
        cy += (my - cy) * 0.12;
        var rect = section.getBoundingClientRect();
        var rx = cx - rect.left;
        var ry = cy - rect.top;
        applyReveal(cursorR, rx, ry);
        if (ring) { ring.style.left = rx + 'px'; ring.style.top = ry + 'px'; }
        rafId = requestAnimationFrame(tick);
      }

      /* Cursor tracking: only on hover-capable devices (not touch) */
      if (!window.matchMedia('(hover: none)').matches) {
        section.addEventListener('mouseenter', function (e) {
          inside = true;
          mx = e.clientX; my = e.clientY; cx = mx; cy = my;
          if (ring) ring.style.opacity = '1';
          if (!rafId) rafId = requestAnimationFrame(tick);
        });
        section.addEventListener('mousemove', function (e) { mx = e.clientX; my = e.clientY; });
        section.addEventListener('mouseleave', function () {
          inside = false;
          if (ring) ring.style.opacity = '0';
          cancelAnimationFrame(rafId); rafId = null;
          var rect = section.getBoundingClientRect();
          applyReveal(0, cx - rect.left, cy - rect.top);
        });
      }

      /* ── Pristine: remove idle animation only on toggle click ── */
      if (toggle) {
        toggle.addEventListener('click', function () {
          section.classList.remove('hero--pristine');
        }, { once: true });
      }

      /* Toggle: works on all devices */
      if (toggle) {
        toggle.addEventListener('click', function () {
          isStateB = !isStateB;
          section.classList.toggle('hero--state-b', isStateB);
          cursorR = parseFloat(getComputedStyle(section).getPropertyValue('--cursor-r')) || 180;
          applyState();
          if (inside) {
            var rect = section.getBoundingClientRect();
            applyReveal(cursorR, cx - rect.left, cy - rect.top);
            if (!rafId) rafId = requestAnimationFrame(tick);
          }
          var labelEl = toggle.querySelector('.hero__toggle-label');
          var next = isStateB ? toggle.dataset.labelOn : toggle.dataset.labelOff;
          if (labelEl) labelEl.textContent = next;
          toggle.setAttribute('aria-label', next);
          var revealLabelEl = section.querySelector('.hero__inner--reveal .hero__toggle-label');
          if (revealLabelEl) revealLabelEl.textContent = next;
        });
      }
    }

    function initAll() {
      document.querySelectorAll('.hero[data-section-id]').forEach(function (s) {
        if (s.querySelector('.hero__stage--a')) initHero(s);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (e) {
        var s = e.target && e.target.querySelector ? e.target.querySelector('.hero[data-section-id]') : null;
        if (s && s.querySelector('.hero__stage--a')) initHero(s);
        if (typeof lucide !== 'undefined') lucide.createIcons();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-testimonials-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initTTS() {
    document.querySelectorAll('.tts__tabs').forEach(function (tabs) {
      var navBtns = tabs.querySelectorAll('.tts__nav-btn');
      var panes   = tabs.querySelectorAll('.tts__pane');

      navBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var targetId = btn.dataset.tab;

          navBtns.forEach(function (b) {
            b.classList.remove('is-active');
            b.setAttribute('aria-selected', 'false');
          });
          panes.forEach(function (p) {
            p.classList.remove('is-active');
            p.setAttribute('hidden', '');
          });

          btn.classList.add('is-active');
          btn.setAttribute('aria-selected', 'true');

          var target = tabs.querySelector('#tts-pane-' + targetId);
          if (target) {
            target.classList.add('is-active');
            target.removeAttribute('hidden');
          }
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initTTS);
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initTTS);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-testimonials"] && !Shopify.designMode) return;
  try {
    

(function () {
  function initTestimonialsSliders() {
    var sections = document.querySelectorAll('.testimonials--slider');
    sections.forEach(function (section) {
      var track = section.querySelector('.testimonials__grid');
      var dots = section.querySelectorAll('.testimonials__dot');
      if (!track || !dots.length) return;

      function updateDots() {
        var cards = track.querySelectorAll('.tcard');
        if (!cards.length) return;
        var cardWidth = cards[0].offsetWidth + 2;
        var index = Math.round(track.scrollLeft / cardWidth);
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === index);
        });
      }

      track.addEventListener('scroll', updateDots, { passive: true });

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          var cards = track.querySelectorAll('.tcard');
          if (!cards.length) return;
          var cardWidth = cards[0].offsetWidth + 2;
          track.scrollTo({ left: i * cardWidth, behavior: 'smooth' });
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initTestimonialsSliders);

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initTestimonialsSliders);
  }
}());


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-track-order"] && !Shopify.designMode) return;
  try {
    
(function () {
  var form = document.getElementById('tro-form');
  var errorEl = document.getElementById('tro-error');
  if (!form || !errorEl) return;

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    errorEl.hidden = true;

    var orderInput = form.querySelector('#tro-order');
    var emailInput = form.querySelector('#tro-email');
    var orderNumber = orderInput.value.trim().replace(/^#/, '');
    var email = emailInput.value.trim();

    if (!orderNumber) {
      errorEl.textContent = 'Please enter your order number.';
      errorEl.hidden = false;
      orderInput.focus();
      return;
    }
    if (!email || !email.includes('@')) {
      errorEl.textContent = 'Please enter a valid email address.';
      errorEl.hidden = false;
      emailInput.focus();
      return;
    }

    var btn = form.querySelector('.tro__submit');
    btn.disabled = true;
    btn.style.opacity = '0.6';

    window.location.href =
      '/a/orders?order_number=' + encodeURIComponent(orderNumber) +
      '&email=' + encodeURIComponent(email);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
  function initFAQs() {
    const accordions = document.querySelectorAll('.faq-accordion');
    accordions.forEach(accordion => {
      const headers = accordion.querySelectorAll('.faq-item__header');
      
      headers.forEach(header => {
        header.addEventListener('click', () => {
          const isExpanded = header.getAttribute('aria-expanded') === 'true';
          
          // Optional: close other items
          headers.forEach(h => h.setAttribute('aria-expanded', 'false'));
          
          header.setAttribute('aria-expanded', !isExpanded);
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initFAQs);
  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', initFAQs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {

  function initHeader() {
    var header    = document.querySelector('[data-site-header]');
    var hamburger = document.querySelector('[data-snm-toggle]');
    var mobileNav = document.querySelector('[data-snm]');
    var closeBtn  = mobileNav ? mobileNav.querySelector('[data-snm-close]') : null;
    if (!hamburger || !mobileNav) return;

    function openMenu() {
      hamburger.setAttribute('aria-expanded', 'true');
      mobileNav.classList.add('is-open');
      mobileNav.setAttribute('aria-hidden', 'false');
      if (header) header.classList.add('nav-open');
      document.body.style.overflow = 'hidden';
      /* Make links focusable */
      mobileNav.querySelectorAll('[tabindex="-1"]').forEach(function (el) {
        el.removeAttribute('tabindex');
      });
      /* Focus first link after animation starts */
      var first = mobileNav.querySelector('.snm__link');
      if (first) setTimeout(function () { first.focus(); }, 200);
    }

    function closeMenu() {
      hamburger.setAttribute('aria-expanded', 'false');
      mobileNav.classList.remove('is-open');
      mobileNav.setAttribute('aria-hidden', 'true');
      if (header) header.classList.remove('nav-open');
      document.body.style.overflow = '';
      /* Make links non-focusable again */
      mobileNav.querySelectorAll('a, button').forEach(function (el) {
        if (!el.classList.contains('snm__close')) {
          el.setAttribute('tabindex', '-1');
        }
      });
      hamburger.focus();
    }

    hamburger.addEventListener('click', function () {
      if (hamburger.getAttribute('aria-expanded') === 'true') {
        closeMenu();
      } else {
        openMenu();
      }
    });

    if (closeBtn) closeBtn.addEventListener('click', closeMenu);

    /* Close on nav link click */
    mobileNav.querySelectorAll('.snm__link, .snm__footer-link').forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });

    /* Escape key */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobileNav.classList.contains('is-open')) {
        closeMenu();
      }
    });
  }

  /* Lucide icons re-init */
  function initIcons() {
    if (typeof lucide !== 'undefined') lucide.createIcons();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeader();
    initIcons();
  });

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () {
      initHeader();
      initIcons();
    });
    document.addEventListener('shopify:section:select', initIcons);
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    

(function () {

  /* ── Gallery: mobile scroll-snap + desktop transform carousel ─── */

  function initGallery() {
    var galleries = document.querySelectorAll('.pdp__gallery');
    galleries.forEach(function (gallery) {
      var track    = gallery.querySelector('.pdp__gallery-track');
      var dots     = gallery.querySelectorAll('.pdp__dot');
      var prevBtn  = gallery.querySelector('.pdp__arrow--prev');
      var nextBtn  = gallery.querySelector('.pdp__arrow--next');
      var thumbsEl = gallery.closest('.pdp__media') && gallery.closest('.pdp__media').querySelector('.pdp__thumbs');
      var thumbs   = thumbsEl ? thumbsEl.querySelectorAll('.pdp__thumb') : [];
      var slides   = track ? track.querySelectorAll('.pdp__slide') : [];
      var total    = slides.length;
      var current  = 0;
      if (!track) return;

      /* ─── Desktop carousel (transform-based) ─────────────────── */

      function isDesktop() {
        return window.matchMedia('(min-width: 1024px)').matches;
      }

      function goTo(index) {
        /* Navegación circular: wrap en ambos extremos */
        if (index < 0) index = total - 1;
        if (index >= total) index = 0;
        current = index;

        /* Deslizar el track */
        track.style.transform = 'translateX(-' + (current * 100) + '%)';

        /* Actualizar thumbnails */
        thumbs.forEach(function (t, i) {
          t.classList.toggle('is-active', i === current);
        });

        /* Hacer scroll del thumbnail activo al view si está fuera */
        if (thumbsEl && thumbs[current]) {
          thumbs[current].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        }

        /* Sincronizar dots (mobile fallback) */
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === current);
        });
      }

      /* Ocultar ambas flechas solo si hay 1 imagen */
      if (total <= 1) {
        if (prevBtn) prevBtn.classList.add('is-hidden');
        if (nextBtn) nextBtn.classList.add('is-hidden');
      }

      /* Clicks en flechas */
      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

      /* Clicks en thumbnails */
      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () { goTo(i); });
      });

      /* Teclado: ← → cuando la galería tiene foco */
      gallery.addEventListener('keydown', function (e) {
        if (!isDesktop()) return;
        if (e.key === 'ArrowLeft')  { e.preventDefault(); goTo(current - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
      });

      /* ─── Mobile: scroll-snap sync con dots ──────────────────── */

      function updateDotsFromScroll() {
        if (isDesktop()) return;
        var slideWidth = track.offsetWidth;
        if (!slideWidth) return;
        var index = Math.round(track.scrollLeft / slideWidth);
        current = index;
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === index);
        });
      }

      track.addEventListener('scroll', updateDotsFromScroll, { passive: true });

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          if (isDesktop()) { goTo(i); return; }
          track.scrollTo({ left: i * track.offsetWidth, behavior: 'smooth' });
        });
      });

      /* Al cambiar de breakpoint: resetear transform en mobile */
      window.addEventListener('resize', function () {
        if (!isDesktop()) {
          track.style.transform = '';
        } else {
          goTo(current);
        }
      });
    });
  }

  /* ── Sticky ATC: show when main ATC scrolls out of view ─────── */

  function initStickyATC() {
    var mainATC = document.getElementById('atc-button-main');
    var stickyBar = document.getElementById('sticky-atc');
    if (!mainATC || !stickyBar) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (window.innerWidth > 768) return;
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        stickyBar.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
      });
    }, { threshold: 0, rootMargin: '0px 0px -20px 0px' });

    observer.observe(mainATC);
  }

  /* ── AJAX Add to Cart ─────────────────────────────────────────── */

  function initATC() {
    var form = document.getElementById('pdp-form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var btn = document.getElementById('atc-button-main');
      if (!btn || btn.disabled) return;

      var originalLabel = btn.textContent.trim();
      btn.disabled = true;
      btn.textContent = 'Adding...';

      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
      .then(function (res) {
        if (!res.ok) throw new Error('cart_add_failed');
        return fetch('/cart.js');
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {

        /* Update cart count badges */
        var countEls = document.querySelectorAll(
          '[data-cart-count], .cart-count-bubble, .cart-count, .header__cart-count'
        );
        countEls.forEach(function (el) {
          el.textContent = cart.item_count;
        });

        /* Notify cart apps */
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
        document.dispatchEvent(new CustomEvent('product:added', { detail: cart }));

        /* Attempt to open cart drawer (Dawn web component) */
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open(btn);
        }

        btn.textContent = 'Added to Cart';
        setTimeout(function () {
          btn.disabled = false;
          btn.textContent = originalLabel;
        }, 2500);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = originalLabel;
      });
    });
  }

  /* ── Quantity stepper ────────────────────────────────────────── */

  function initStepper() {
    var steppers = document.querySelectorAll('.pdp__stepper');
    steppers.forEach(function (stepper) {
      var input = stepper.querySelector('.pdp__qty-input');
      if (!input) return;
      stepper.querySelectorAll('.pdp__stepper-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var val = parseInt(input.value, 10) || 1;
          var min = parseInt(input.min, 10) || 1;
          if (btn.dataset.action === 'plus') {
            input.value = val + 1;
          } else {
            input.value = Math.max(min, val - 1);
          }
        });
      });
    });
  }

  /* ── Bundle Selector: handle selection ────────────────────────── */

  function initBundles() {
    var bundles = document.querySelectorAll('.pdp__bundle-card');
    var qtyInput = document.getElementById('pdp-qty-hidden');
    if (!bundles.length || !qtyInput) return;

    bundles.forEach(function (card) {
      card.addEventListener('click', function () {
        // Remove selection from all
        bundles.forEach(function (c) { c.classList.remove('is-selected'); });
        
        // Add to current
        card.classList.add('is-selected');
        
        // Update hidden input
        qtyInput.value = card.dataset.qty;
      });
    });
  }

  /* ── Init ────────────────────────────────────────────────────── */

  function init() {
    initGallery();
    initStickyATC();
    initATC();
    initStepper();
    initBundles();
  }

  document.addEventListener('DOMContentLoaded', init);

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
  }

}());


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-testimonials"] && !Shopify.designMode) return;
  try {
    
  function initTestimonialTabs() {
    const sections = document.querySelectorAll('.tabbed-testimonials');
    sections.forEach(section => {
      const btns = section.querySelectorAll('.testimonial-tabs__btn');
      const panes = section.querySelectorAll('.testimonial-tabs__pane');

      btns.forEach(btn => {
        btn.addEventListener('click', () => {
          const tab = btn.dataset.tab;
          
          btns.forEach(b => b.classList.remove('is-active'));
          panes.forEach(p => p.classList.remove('is-active'));
          
          btn.classList.add('is-active');
          section.querySelector(`#pane-${tab}`).classList.add('is-active');
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initTestimonialTabs);
  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', initTestimonialTabs);
  }

  } catch(e) { console.error(e); }
})();
})();
